import type { StringFileResponse } from 'models/FileResponse';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IBlotterColumnDefinition } from 'state/blotters/common/blotter.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { IBlotterRequest, ISearchResponse } from '../blotters/common';
import type { Day, Frequency, QuoteInfo, Reader, ScheduledQuotesActivity, ScheduleRunStatus } from './model';

export interface IScheduledQuotesBlotterRequest extends IBlotterRequest {
  activityScope: ScheduledQuotesActivity;
  page: number;
  size: number;
  filters?: any;
}

export function scheduledQuotesBlotterApiConnector(http: IHttpClient) {
  return {
    search(request: IScheduledQuotesBlotterRequest) {
      return http
        .postJSON<ISearchResponse<IScheduledQuotesBlotterItem>>({
          url: 'api/v1/scheduled-runs/blotter/search',
          body: request,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchColumnDefinition(): Observable<IBlotterColumnDefinition<IScheduledQuotesBlotterItem>[]> {
      return http
        .getJSON<{
          data: { columnDefinitions: IBlotterColumnDefinition<IScheduledQuotesBlotterItem>[] };
          isSuccess: boolean;
        }>({
          url: 'api/v1/scheduled-runs/blotter/column-definitions',
        })
        .pipe(map(({ payload }) => payload.data?.columnDefinitions ?? []));
    },
    fetchCSV(request: IScheduledQuotesBlotterRequest): Observable<StringFileResponse> {
      return http
        .postRAW({
          url: 'api/v1/scheduled-runs/blotter/csv',
          body: request,
        })
        .pipe(
          map(response => ({
            data: response.payload,
            filename: response.attachmentName,
          })),
        );
    },
  };
}

export interface ScheduledRangeOrDays {
  startDate?: string;
  endDate?: string;
  triggerDays: readonly Day[];
}
export interface IScheduledQuotesBlotterItem {
  id: string;
  readers: readonly Reader[];
  etag: string;
  status: ScheduleRunStatus;
  name: string;
  requester: string;
  type: 'range' | 'days';
  triggerTime: string;
  scheduledRangeOrDays: ScheduledRangeOrDays;
  frequency?: Frequency;
  nextRunTime?: string;
  lastRunTime?: string;
  timeZone: string;
  comment?: string;

  quotes: QuoteInfo[];
}
